import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import { Radio } from 'antd';

class SelectSortDirection extends React.PureComponent {
  availableItems = [1, -1];

  onChange = (e) => {
    this.props.onChange(e.target.value);
  };

  render() {
    const { style, value } = this.props;

    return (
      <Radio.Group onChange={this.onChange} value={value} style={style}>
        {this.availableItems.map((item) => (
          <Radio.Button key={item} value={item}>
            {this.props.t(`records.cards.config.sortDirection.${String(item) == '-1' ? 'desc' : 'asc'}`)}
          </Radio.Button>
        ))}
      </Radio.Group>
    );
  }
}

SelectSortDirection.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.number,
};

export default withTranslation()(SelectSortDirection);
